/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoOtherSubtype = typeof ListingDetailResponseDtoOtherSubtype[keyof typeof ListingDetailResponseDtoOtherSubtype] | null;


export const ListingDetailResponseDtoOtherSubtype = {
  RETAIL: 'RETAIL',
  PRODUCTION: 'PRODUCTION',
  WAREHOUSE: 'WAREHOUSE',
  OFFICE: 'OFFICE',
  GARAGE_OR_PARKING: 'GARAGE_OR_PARKING',
  HOTEL_OR_GUESTHOUSE: 'HOTEL_OR_GUESTHOUSE',
  RESTAURANT: 'RESTAURANT',
  MULTIFUNCTIONAL_BUILDING: 'MULTIFUNCTIONAL_BUILDING',
  APARTMENT_BUILDING: 'APARTMENT_BUILDING',
  MEDICAL: 'MEDICAL',
} as const;
